import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

/**
 * Returns a translation key for the given count using Intl.PluralRules.
 * Usage: {{ 'Some.Key.Prefix' | translatePlural: count }}
 * Produces keys like Some.Key.Prefix.one, Some.Key.Prefix.other, etc.
 */
@Pipe({
	name: 'translatePlural',
	standalone: true,
	pure: false // required to update the value when the promise is resolved
})
export class TranslatePluralPipe extends TranslatePipe implements PipeTransform {
	private readonly translateService = inject(TranslateService);

	transform(keyPrefix: string | null, count: number | null): string {
		if (!keyPrefix) {
			return '';
		}

		const prefix = keyPrefix.endsWith('.') ? keyPrefix : `${keyPrefix}.`;

		if (count == null) {
			return super.transform(`${prefix}other`);
		}

		const languageCode = this.translateService.currentLang || this.translateService.defaultLang;
		const suffix = new Intl.PluralRules(languageCode).select(count);

		return super.transform(`${prefix}${suffix}`);
	}
}
